import svTranslations from '../../locales/sv/default.json.js';
import jaTranslations from '../../locales/ja/default.json.js';
import elTranslations from '../../locales/el/default.json.js';
import itTranslations from '../../locales/it/default.json.js';
import ruTranslations from '../../locales/ru/default.json.js';
import ptTranslations from '../../locales/pt/default.json.js';
import zhTranslations from '../../locales/zh/default.json.js';
import arTranslations from '../../locales/ar/default.json.js';
import nlTranslations from '../../locales/nl/default.json.js';
import deTranslations from '../../locales/de/default.json.js';
import koTranslations from '../../locales/ko/default.json.js';
import frTranslations from '../../locales/fr/default.json.js';
import esTranslations from '../../locales/es/default.json.js';
import enTranslations from '../../locales/en/default.json.js';
import trTranslations from '../../locales/tr/default.json.js';

/**
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */
var translationsMap = {
  sv: svTranslations,
  ja: jaTranslations,
  el: elTranslations,
  it: itTranslations,
  ru: ruTranslations,
  pt: ptTranslations,
  zh: zhTranslations,
  ar: arTranslations,
  nl: nlTranslations,
  de: deTranslations,
  ko: koTranslations,
  fr: frTranslations,
  es: esTranslations,
  en: enTranslations,
  tr: trTranslations
};
var getTranslations = function getTranslations(locale) {
  return translationsMap[locale] || enTranslations;
};

export { getTranslations, translationsMap };
